import { render, staticRenderFns } from "./OfferMaterials.vue?vue&type=template&id=32f21d52&scoped=true&"
import script from "./OfferMaterials.vue?vue&type=script&lang=js&"
export * from "./OfferMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f21d52",
  null
  
)

export default component.exports